import lang from '../../../lib/language';

import iconCheck from '../../../assets/bigImages/big-green-check.png';
import Button from '../../../shared_components/Button/Button';

import styles from '../AddYourBankAccount/AddBankAccountScreen/AddBankAccountScreen.module.scss';

type Props = {
  isOpen: boolean;
  onContinue: () => void;
};

const AddCryptoAddressScreen = ({ isOpen, onContinue }: Props) => (
  <>
    {isOpen && (
      <div className={styles.wrapper}>
        <div className={styles.contentWrapper}>
          <div className={styles.imageWrapper}>
            <img className={styles.image} src={iconCheck} alt="Crypto wallet added!" />
          </div>
          <div className={styles.textWrapper}>
            <h6 className={styles.title}>{lang.payoutsAddCryptoSuccessTitle()}</h6>
            <span className={styles.description}>{lang.payoutsAddCryptoSuccessDescription1()}</span>
            <div className={styles.secondDescription}>
              <span className={styles.description}>{lang.payoutsAddCryptoSuccessDescription2()}</span>
            </div>
          </div>
          <div className={styles.buttonWrapper}>
            <div className={styles.continueBtn}>
              <Button fullWidth onClick={onContinue}>
                {lang.commonContinueButton()}
              </Button>
            </div>
          </div>
        </div>
      </div>
    )}
  </>
);

export default AddCryptoAddressScreen;
